import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as echarts from 'echarts';
import { Dropdown, DropdownOption } from '@abb/abb-common-ux-react';
import PeriodList from '../../Period-Dropdown-list/period-dropdown-list';
import './energy-monitoring.css';
import energyMonitoringData from './energy-monitoring.json';
import axios from 'axios';
import { getToken } from "../../Authentication/get-token";
import { BASE_URL } from '../../../strings';
 
 
const EnergyMonitorBar = () => {
  const chartRef = useRef(null);
  const [showContractual, setShowContractual] = useState(false);
  const [apiData, setApiData] = useState([]);
 
  const [dropdownValues, setDropdownValues] = useState(
    energyMonitoringData.dropdowns.reduce((acc, dropdown) => {
      acc[dropdown.label] = dropdown.placeholder;
      return acc;
    }, {})
  );
 
  const fetchChartData = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}emapi/energy_monitoring`,getToken());
      setApiData(response.data.data || []);
    } catch (err) {
      console.error('Error fetching energy monitoring data:', err);
    }
  }, []);
 
  useEffect(() => {
    fetchChartData();
  }, [fetchChartData]);
 
  const chartOptions = useMemo(() => {
    const data = apiData;
 
    return {
      tooltip: energyMonitoringData.tooltip,
      xAxis: {
        ...energyMonitoringData.xAxis,
        data: data.map(item => item[energyMonitoringData.xAxis.dataField]),
      },
      yAxis: energyMonitoringData.yAxis,
      series: energyMonitoringData.series.map((series, index) => ({
        ...series,
        data: data.map(item => item[`value${index + 1}`]),
        itemStyle: {
          color: index === 0 ? '#FF4754' : index === 1 ? '#F2AC66' : '#3B82F6' // add more colors if needed
        }
      })),
    };
  }, [apiData]);
 
  useEffect(() => {
    if (!chartRef.current || apiData.length === 0) return;
 
    const chart = echarts.init(chartRef.current);
    chart.setOption(chartOptions);
 
    return () => {
      chart.dispose();
    };
  }, [chartOptions, apiData]);
 
  const handleDropdownChange = (label, value) => {
    setDropdownValues({ ...dropdownValues, [label]: value });
  };
 
  const handleCheckboxChange = (event) => {
    setShowContractual(event.target.checked);
  };
 
  const dropdowns = useMemo(() => {
    return energyMonitoringData.dropdowns.map((dropdown, index) => (
      <Dropdown 
        key={`dropdown-${dropdown.key}-${index}`}
        label={dropdown.label}
        placeholder={dropdown.placeholder}
        value={dropdownValues[dropdown.label]}
        onChange={(value) => handleDropdownChange(dropdown.label, value)}
      >
        {dropdown.options.map(option => (
          <DropdownOption key={option.key} label={option.label} value={option.value} />
        ))}
      </Dropdown>
    ));
  }, [energyMonitoringData.dropdowns, dropdownValues]);
 
  return (
    <div className='energy-monitoring'>
      <div className='indicator-container-line'>
        {dropdowns}
        <PeriodList />
        <label className='checkbox' style={{ display: 'flex', alignItems: 'center' }}>
          <input
            type='checkbox'
            checked={showContractual}
            onChange={handleCheckboxChange}
            style={{ accentColor: 'royalblue', paddingTop: '35px' }}
            className='checkbox'
          />
          <span className='label-title'>{energyMonitoringData.checkbox.label}</span>
         
        </label>
      </div>
      <div ref={chartRef} className='energy-moni-chart' />
    </div>
  );
};
 
export default EnergyMonitorBar;